export function numberWithCommas(x: number) {
  return x.toLocaleString("en");
}
